module.exports = __webpack_public_path__ + "static/img/logo_en.7877f60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/head/logo_en.jpg
// module id = ZWPb
// module chunks = 29